export default __webpack_public_path__ + "images/0x49d5c2bdffac6ce2bfdb6640f4f80f226bc10bab.png";